import React from 'react';

import classnames from 'classnames';

import { EventArea } from '../../../../analytics-library/entry/sendEvent';
import { ActionType, getActionType } from '../../../../sharedModules/getActionType';
import getButtonText from '../../../modules/getButtonText';
import type { Deal } from '../../../types/Deal';
import { ArrowRight } from '../ArrowRight';
import { useHawkWidgetContext } from '../HawkWidget/HawkWidgetContext';
import { TargetEnum } from '../TrackedLink/model';

interface ButtonProps {
  deal: Deal;
  displayMerchant?: boolean;
  className?: string;
  buttonText?: string;
  actionType?: ActionType;
  customTarget?: TargetEnum;
}

const Button: React.FC<ButtonProps> = ({
  deal,
  displayMerchant,
  className,
  buttonText,
  actionType,
  customTarget,
}) => {
  const {
    buttonType,
    translate,
    genericSharedComponents: { AffiliateLink },
    articleUrl,
  } = useHawkWidgetContext();

  return (
    <AffiliateLink
      deal={deal}
      actionType={
        actionType ||
        getActionType({
          link: deal.offer.link,
          articleUrl,
          productType: deal.product_type,
        })
      }
      // We want to track exact model with click
      label={deal?.model_matched?.join(',')}
      className={classnames(buttonType !== 'chevron' && (className ?? 'button'))}
      customTarget={customTarget}
      areaClicked={EventArea.CTA}
    >
      {buttonType === 'chevron' ? (
        <ArrowRight />
      ) : (
        buttonText || getButtonText(deal, displayMerchant, translate)
      )}
    </AffiliateLink>
  );
};

export default Button;
